import { Pipe, PipeTransform } from "@angular/core";
import { fileExtensionPattern } from "../custom-validators/form-validators";
import { IconsConstants } from "../common";
import { SvgIcon } from "../interfaces";
import { IMAGE_EXTENSIONS, VIDEO_EXTENSIONS } from "src/app/core/common";

@Pipe({
    name: 'fileExtensionIcon',
    standalone: true
})
export class IconFromFileExtensionPipe implements PipeTransform {
    IconsConstants = IconsConstants;

    transform(value: string): SvgIcon {
        const fileExtension: string = value?.match(fileExtensionPattern)?.[1];
        if (fileExtension) {
            const icon: SvgIcon = IconsConstants[`${fileExtension.toUpperCase()}_ICON`];
            if(icon) {
                return icon;
            }
    
            if (Object.values(IMAGE_EXTENSIONS).includes(fileExtension as IMAGE_EXTENSIONS)) {
                return IconsConstants.IMAGE_FILE_ICON;
            } else if (Object.values(VIDEO_EXTENSIONS).includes(fileExtension as VIDEO_EXTENSIONS)) {
                return IconsConstants.VIDEO_FILE_ICON;
            } else {
                return IconsConstants.DEFAULT_FILE_ICON;
            }
        }
        return IconsConstants.DEFAULT_FILE_ICON;
    }
}